import useExampleStore from '../store/useExampleStore';
import { useShallow } from 'zustand/react/shallow';

export default function ExampleStore() {
  const hello = useExampleStore.use.hello();
  const setName = useExampleStore.use.setName();
  const reset = useExampleStore.use.reset();

  const { helloShallow } = useExampleStore(
    useShallow((state) => ({ helloShallow: state.hello})),
  )
  
  return (
    <>
      <div>
        <button onClick={()=>setName('world')}>World</button>&nbsp;
        <button onClick={() => reset()}>Reset</button>
      </div>
      <div style={{display: "flex"}}>
        <span>Hello :</span>
        <span>【{ hello}】</span>
      </div>
      <div style={{display: "flex"}}>
        <span>Hello  :</span>
        <span>【{ helloShallow}】</span>
        </div>
    </>
  );  
}